// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__XV9_D","size_800":"Container_size_800__5HeGk"};